"use client";
import { createContext, useContext } from "react";
import { useRouter } from "next/navigation";
import { saveRent } from "lib/actionFetch";
import { clearPersistedRent, persistRentData, useRentStore } from "./rentStore";

const RentContext = createContext({});

export const RentProvider = ({ children }) => {
  const router = useRouter();
  const rentData = useRentStore((state) => state.rentData);
  const loading = useRentStore((state) => state.loading);
  const setLoading = useRentStore((state) => state.setLoading);
  const setRentData = useRentStore((state) => state.setRentData);
  const clearRentData = useRentStore((state) => state.clearRentData);
  const hydrateRent = useRentStore((state) => state.hydrateRent);

  const handleSideRent = (values) => {
    setLoading(true);
    setRentData(values);
    persistRentData(values);
    setLoading(false);
    router.push("/rent_checkout");
  };

  const getRent = () => {
    if (!rentData) {
      setLoading(true);
      hydrateRent();
      setLoading(false);
    }
  };

  const createRent = async (values, options = {}) => {
    try {
      setLoading(true);
      const data = { ...rentData, ...values };

      data.rent = data.data?._id;
      data.pickupDate = data.pickupDate?.toISOString?.() || data.pickupDate;
      data.returnDate = data.returnDate?.toISOString?.() || data.returnDate;
      data.payAmount = parseInt(data.totalPrice);
      data.pricePerDay = data.pricePerDay ?? 0;
      data.totalDays = data.totalDays ?? 0;
      if (data.specialRequirements) {
        data.specialRequest = data.specialRequirements;
      }
      delete data.data;

      await saveRent(data, options);
      clearRentData();
      clearPersistedRent();
      router.push("/");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <RentContext.Provider
      value={{
        handleSideRent,
        rentData,
        getRent,
        createRent,
        loading,
        setLoading,
      }}
    >
      {children}
    </RentContext.Provider>
  );
};

export const useRentContext = () => useContext(RentContext);
